export default __webpack_public_path__ + "static/media/DashboardIconGrey.b41c3e03.svg";